import Modal from "./Modal";

export default class ModalContacts extends Modal {
    params = {};
    form = null;
    btnSubmit = null;

    constructor() {
        super();
        this.addContent();

    }

    /** @private */
    addContent = () => {
        this.modal.classList.add("contacts");

        this.setContent('<h4>Оставьте свои контакты</h4>')

        this.form = document.createElement('form');
        this.form.setAttribute('enctype', 'multipart/form-data');
        this.form.className = 'contacts-form';

        this.form.innerHTML = `
            <div class="contacts-form__fields">
                <input type="hidden" name="form_title" value="Оставьте свои контакты">
                <input type="hidden" name="page_url" value="${location.href}">

                <input class="form-input" type="text" name="name" placeholder="Ваше имя">
                <input class="form-input" type="text" name="phone" placeholder="Ваш номер телефона">
                <label class="form-label" for="">
                    <input class="form-checkbox border" type="checkbox" name="consent">
                    <span class="text-tiny">Подтверждаю ознакомление с <strong><a href="/privacy-policy/">политикой обработки персональных данных</a></strong> и даю согласие на обработку персональных данных с целью установления с пользователем сайта, приложения обратной связи</span>
                </label>
            </div>
    `;

        this.btnSubmit = document.createElement('button');
        this.btnSubmit.classList.add('contacts-form__btn', 'btn-primary');
        this.btnSubmit.type = 'submit';
        this.btnSubmit.innerText = 'Отправить';

        this.form.appendChild(this.btnSubmit);
        this.form.addEventListener('submit', this.handleSubmit);

        this.modalContent.appendChild(this.form);
        // this.modalContent.appendChild(this.modalClose);
    }

    setParams = (params) => {
        this.params = params;
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(this.form);

        const fields = Object.fromEntries(formData);

        if (!this.validateFields(fields)) {
            return;
        }

        Object.entries(this.params).forEach(([key, value]) => {
            fields[key] = value;
        });

        BX.ajax.runComponentAction('vistegra:form.feedback', 'submitForm', {
            mode: 'ajax',
            data: {fields}
        }).then((response) => {
            switch (response.data.status) {
                case 'success':
                    window.app.modalForms.showSuccess();
                    this.hide();
                    break;
                case 'error':
                    window.app.modalForms.showMessage(response.data.message, 'Ошибки в форме');
                    break;
                default:
                    window.app.modalForms.showError();
            }

        }).catch((error) => {
            console.error('Ошибка:', error);
            window.app.modalForms.showError();
        });
    }

    validateFields = (fields) => {
        const errors = [];

        // Валидация имени
        if (!fields.name || fields.name.trim() === '') {
            errors.push('Поле "Имя" обязательно для заполнения');
        } else if (!/^[a-zA-Zа-яА-Я\s]+$/.test(fields.name)) {
            errors.push('"Имя" должно содержать только буквы и пробелы');
        }

        // Валидация номера телефона (не должно быть букв)
        if (!fields.phone || fields.phone.trim() === '') {
            errors.push('Поле "Телефон" обязательно для заполнения');
        } else if (/[a-zA-Zа-яА-Я]/.test(fields.phone)) {
            errors.push('"Телефон" не должен содержать буквы');
        }

        // Валидация согласия на обработку персональных данных
        if (!fields.consent || fields.consent !== 'on') {
            errors.push('Вы не дали согласие на обработку персональных данных');
        }

        if (errors.length) {
            window.app.modalForms.showMessage(errors.join('<br>'), 'Ошибки в форме');
            return false;
        }

        return true;
    }

}